import httpservice from "./httpservice";
import fileDownloadService from "./fileDownloadService";

class OrganizationService {
  get(query = {}) {
    const params = { plan: "" };
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.page) params.page = query.page;
    if (query.plan !== "ALL") params.plan = query.plan;
    if (query?.limit) params.limit = query.limit;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.state) params.state = query.state;
    if (query?.status && query?.status !== "ALL") params.status = query.status;
    if (query?.subscriptionStatus && query?.subscriptionStatus !== "ALL") params.subscriptionStatus = query.subscriptionStatus;
    if (query?.isFreeTrial && query?.isFreeTrial !== "ALL") params.isFreeTrial = query.isFreeTrial;
    // if (query?.state) {
    //   return httpservice.get("/admin/cp/organizations/by-location", { params });
    // }
    return httpservice.get("/admin/cp/organizations/", { params });
  }
  getFirsConnected(query = {}) {
    const params = { plan: "" };
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.page) params.page = query.page;
    if (query.plan !== "ALL") params.plan = query.plan;
    if (query?.limit) params.limit = query.limit;
    if (query?.datePreset) params.datePreset = query.datePreset;
    // Only CUSTOM needs dateFrom/dateTo — all other presets are datePreset alone.
    if (query?.datePreset === "CUSTOM") {
      if (query?.dateFrom) params.dateFrom = query.dateFrom;
      if (query?.dateTo) params.dateTo = query.dateTo;
    }
    if (query?.state) params.state = query.state;
    if (query?.status && query?.status !== "ALL") params.status = query.status;
    if (query?.subscriptionStatus && query?.subscriptionStatus !== "ALL") params.subscriptionStatus = query.subscriptionStatus;
    if (query?.isFreeTrial && query?.isFreeTrial !== "ALL") params.isFreeTrial = query.isFreeTrial;
    if (query?.mode) params.mode = query.mode;
    if (query?.sortBy) params.sortBy = query.sortBy;
    if (query?.sortOrder) params.sortOrder = query.sortOrder;
    if (query?.country) params.country = query.country;
    // if (query?.state) {
    //   return httpservice.get("/admin/cp/organizations/by-location", { params });
    // }

    return httpservice.get("/admin/cp/organizations/firs-connected/", { params });
  }
  /**
   * GET /admin/cp/organizations/export
   * Filters: keyword, dateFrom, dateTo, status, plan, subscriptionStatus, isFreeTrial, country, state
   */
  export(query = {}, callback) {
    const params = {};
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.status && query.status !== "ALL") params.status = query.status;
    if (query?.plan && query.plan !== "ALL") params.plan = query.plan;
    if (query?.subscriptionStatus && query.subscriptionStatus !== "ALL") params.subscriptionStatus = query.subscriptionStatus;
    if (query?.isFreeTrial && query.isFreeTrial !== "ALL") params.isFreeTrial = query.isFreeTrial;
    if (query?.country) params.country = query.country;
    if (query?.state) params.state = query.state;
    if (query?.headers) params.headers = query.headers;
    if (query?.format) params.format = query.format;

    const today = new Date().toISOString().slice(0, 10);
    return fileDownloadService.download(`/admin/cp/organizations/export`, `organizations-export-${today}.csv`, callback, params);
  }
  getOne(query = {}) {
    const params = {};
    if (query?.id) params.id = query.id;
    return httpservice.get("/admin/cp/organizations/single", { params });
  }
  getFirsIntegration(query = {}) {
    const params = {};
    if (query?.organizationId) {
      params.organizationId = query.organizationId;
    }
    return httpservice.get("/admin/cp/integrations", { params });
  }
  subscriptionPeriodStats(query = {}) {
    const params = { plan: "" };
    if (query?.keyword) params.keyword = query.keyword;
    if (query.plan !== "ALL") params.plan = query.plan;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.state) params.state = query.state;
    if (query?.status && query?.status !== "ALL") params.status = query.status;
    if (query?.subscriptionStatus && query?.subscriptionStatus !== "ALL") params.subscriptionStatus = query.subscriptionStatus;
    if (query?.isFreeTrial && query?.isFreeTrial !== "ALL") params.isFreeTrial = query.isFreeTrial;
    return httpservice.get("/admin/cp/organizations/sub-period-stats", { params });
  }
  getInvoice(query = {}) {
    const params = {};
    if (query?.id) params.id = query.id;
    return httpservice.get("/admin/cp/invoices/single", { params });
  }
  getInvoices(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.id) params.organizationId = query.id;
    if (query.plan !== "ALL") params.plan = query.plan;
    if (query?.limit) params.limit = query.limit;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.period !== "ALL") params.period = query.period;
    return httpservice.get("/admin/cp/organizations/invoices", { params });
  }
  transmittedInvoices(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.status) params.status = query.status;
    if (query?.limit) params.limit = query.limit;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.requestId) params.requestId = query.requestId;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.period !== "ALL") params.period = query.period;
    return httpservice.get(`/admin/cp/organizations/${query.id}/organization-invoices`, { params });
  }
  fileRequests(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.status) params.status = query.status;
    if (query?.limit) params.limit = query.limit;
    if (query?.datePreset) params.datePreset = query.datePreset;
    // Only CUSTOM needs dateFrom/dateTo — other presets are datePreset alone.
    if (query?.datePreset === "CUSTOM") {
      if (query?.dateFrom) params.dateFrom = query.dateFrom;
      if (query?.dateTo) params.dateTo = query.dateTo;
    }
    if (query?.sortBy) params.sortBy = query.sortBy;
    if (query?.sortOrder) params.sortOrder = query.sortOrder;
    if (query?.period && query?.period !== "ALL") params.period = query.period;
    return httpservice.get(`/admin/cp/organizations/${query.id}/file-requests`, { params });
  }
  getSubscriptionPlans() {
    return httpservice.get("/admin/cp/meta/plans");
  }
  updateInvoice(data) {
    return httpservice.put("/admin/cp/invoices/payment", data);
  }
  cancelSubscription(data) {
    return httpservice.put("/admin/cp/organizations/subscription/cancel", data);
  }
  getFirsBusinesses(id) {
    return httpservice.get("/admin/cp/organizations/firs-businesses", { params: { id } });
  }
  updateFirsBusinessLimit(id, maxBusinesses) {
    return httpservice.patch("/admin/cp/organizations/firs-business-limit", { maxBusinesses }, { params: { id } });
  }
  removeFirsBusiness(id, businessId) {
    return httpservice.delete("/admin/cp/organizations/firs-businesses", { params: { id, businessId } });
  }
  updateFirsLiveMode(id, isLiveMode) {
    return httpservice.patch("/admin/cp/organizations/firs-live-mode", { isLiveMode }, { params: { id } });
  }
  upgradeSubscription(data) {
    return httpservice.post("/admin/cp/organizations/subscription/upgrade", data);
  }
  renewSubscription(data) {
    return httpservice.post("/admin/cp/organizations/subscription/renew", data);
  }
  getAdministrators(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.limit) params.limit = query.limit;
    if (query?.status && query?.status !== "ALL") params.status = query.status;
    if (query?.organizationId) params.organizationId = query.organizationId;
    return httpservice.get("/admin/cp/organizations/administrators", {
      params,
    });
  }
  addAdministrator(data = {}) {
    return httpservice.post("/admin/cp/organizations/administrators/setup", data);
  }
  activateAdmin(id) {
    return httpservice.put(`/admin/cp/organizations/administrators/activate?id=${id}`, {});
  }
  deactivateAdmin(id) {
    return httpservice.put(`/admin/cp/organizations/administrators/deactivate?id=${id}`, {});
  }
  makeSuperAdmin(id) {
    return httpservice.put(`/admin/cp/organizations/administrators/change-super?id=${id}`, {});
  }
  getActivities(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.limit) params.limit = query.limit;
    return httpservice.get("/admin/cp/activities/organization", {
      params,
    });
  }
  getUser(query = {}) {
    const params = {};
    if (query?.id) params.id = query.id;
    return httpservice.get("/admin/cp/users/single", { params });
  }
  getUsers() {
    return httpservice.get("");
  }
}

export default new OrganizationService();
